import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthenticationService } from '../core/authentication/authentication.service';
import { ApplicationStore, ApplicationStoreType } from '../core/store/application.store';
import { ThemeService, Theme } from '../core/services/theme.service';
import { environment } from '../../environments/environment';

@Component({
    selector: 'juyo-no-access-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: 'no-access.scss',
    template: `
        <div class="page-body">
            <div class="form-container">
                <div class="panel">
                    @if (themeService.theme() === Theme.Dark) {
                        <img class="logo" src="../../assets/logos/logo_white.png" alt="logo" />
                    } @else {
                        <img class="logo" src="../../assets/logos/logo_dark.png" alt="logo" />
                    }
                    <p class="message">
                        Sorry, it looks like you don't have access. You can go back to the analytics platform.
                    </p>
                    <button type="button" class="back-button" (click)="onBack()">Back</button>
                </div>
            </div>
            <div class="image-container">
                <img class="img" src="../../assets/images/signin.png" alt="signin" />
            </div>
        </div>
    `,
})
export class NoAccessPage {
    protected themeService = inject(ThemeService);
    protected readonly Theme = Theme;

    private authService = inject(AuthenticationService);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    protected onBack(): void {
        const tokens = this.authService.getTokensForExport();
        const encoded = btoa(JSON.stringify(tokens));
        const selectedChain = this.applicationStore.selectedChain();
        const chainParam = selectedChain ? `?chainId=${selectedChain.id}` : '';
        window.location.href = `${environment.externalPlatformUrl}${chainParam}#tokens=${encoded}`;
    }
}
